export default "__VITE_ASSET__CuMJGXNh__"